// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"LangSelector-styles_itemContainer__3Aak4","itemLabel":"LangSelector-styles_itemLabel__3-VxB"};